import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { ButtonLink } from '../../../components/ButtonLink';
import { REIMBURSEMENT_STEP_PATHS } from '../routes';
import { useReimbursementDraft } from '../state/reimbursementDraftContext';
import { getNextStep, isLastStep } from '../steps';
import type { ReimbursementStepId } from '../types';

export type ReimbursementStepActionsProps = {
    currentStep: ReimbursementStepId;
    nextDisabled?: boolean;
    onNext?: () => void;
};

// Going back is the header's job, so this only ever moves the partner forward.
export function ReimbursementStepActions({
    currentStep,
    nextDisabled = false,
    onNext,
}: ReimbursementStepActionsProps): ReactElement {
    const { t } = useTranslation();
    const { offerRequestLeadUuid, origin } = useReimbursementDraft();
    const next = getNextStep(currentStep);

    return (
        <Stack direction="row" sx={{ justifyContent: 'flex-end', pt: 1 }}>
            {next && !onNext ? (
                <ButtonLink
                    variant="contained"
                    to={REIMBURSEMENT_STEP_PATHS[next.id]}
                    params={{ offerRequestLeadUuid }}
                    search={{ from: origin }}
                    replace
                    disabled={nextDisabled}>
                    {t('REIMBURSEMENT.ACTIONS.NEXT')}
                </ButtonLink>
            ) : (
                <Button variant="contained" disabled={nextDisabled} onClick={onNext}>
                    {isLastStep(currentStep) ? t('REIMBURSEMENT.ACTIONS.SUBMIT') : t('REIMBURSEMENT.ACTIONS.NEXT')}
                </Button>
            )}
        </Stack>
    );
}
